import * as React from 'react';
import { useDayPicker } from '../../contexts';
/** Render the Footer component (empty as default).*/
export function Footer() {
    var _a = useDayPicker(), footer = _a.footer, styles = _a.styles, tfoot = _a.classNames.tfoot;
    if (!footer)
        return React.createElement(React.Fragment, null);
    return (React.createElement("tfoot", { className: tfoot, style: styles.tfoot },
        React.createElement("tr", null,
            React.createElement("td", { colSpan: 8 }, footer))));
}
//# sourceMappingURL=Footer.js.map